import React, {useRef} from "react";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import isEmpty from "is-empty";

const componentName = "AsyncSearch";

const AsyncSearch = ({
 id,
 title,
 labelKey,
 isLoading,
 onSearch,
 options,
 onChange,
 selected,
 index,
 disabled = false,
 minLength = 2,
}) => {
    const asyncTypeAheadRef = useRef(null);
    const inputId = index !== undefined ? `${componentName}-${id}-${index}` : `${componentName}-${id}`;

    const handleChange = (item) => {
        onChange(item, index);
        if (!isEmpty(item)) {
            asyncTypeAheadRef.current.blur();
        }
    }

    return (<>
        <label id={`${inputId}Label`} className="d-block">
            {title}
        </label>
        <AsyncTypeahead
            id={`${inputId}Typeahead`}
            filterBy={() => true}
            inputProps={{
                id: inputId
            }}
            labelKey={labelKey}
            isLoading={isLoading}
            minLength={minLength}
            onSearch={(e) => onSearch(e, index)}
            options={options}
            selected={selected}
            onChange={handleChange}
            disabled={disabled}
            ref={asyncTypeAheadRef}
        />
    </>)
}

export default AsyncSearch;
